/* eslint-disable prefer-template */
import React from 'react';

import ApplicationState from 'store/interfaces';
import Chart from 'chart.js';
import palette from 'theme/palette';
import { connect } from 'react-redux';
import { EnvironmentsCostGraphFields } from 'modules/monitor/interfaces';
import { Grid } from '@material-ui/core';
import { formatCurrency } from 'utils/helpers';
import { generateLabels, defaultGraphConfig } from 'utils/graphs';

interface EnvironmentsCostGraphContentProps {
  environmentsCostGraphFields: EnvironmentsCostGraphFields;
}

const EnvironmentsCostGraphContent = ({
  environmentsCostGraphFields,
}: EnvironmentsCostGraphContentProps) => {
  const containerRef = React.useRef<HTMLCanvasElement>(null);
  const labels = generateLabels(environmentsCostGraphFields?.metrics);

  const config = defaultGraphConfig({
    labels,
    datasets: [
      {
        data: environmentsCostGraphFields?.metrics?.map(item => item.cost),
        backgroundColor: palette.deepBlue,
        borderColor: palette.deepBlue,
        fill: false,
        tension: 0.4,
      },
    ],
  });

  config.options.tooltips.callbacks = {
    label(tooltipItem) {
      return formatCurrency(tooltipItem.value);
    },
  };

  React.useEffect(() => {
    let chart;

    if (containerRef.current) {
      chart = new Chart(containerRef.current, config);
    }
    return () => chart?.destroy();
  }, [containerRef, config]);

  return (
    <Grid container>
      <canvas ref={containerRef} width="auto" height="100"></canvas>
    </Grid>
  );
};

const mapStateToProps = ({
  monitor: { environmentsCostGraphFields },
}: ApplicationState) => ({ environmentsCostGraphFields });

export default connect(mapStateToProps, {})(EnvironmentsCostGraphContent);
